// extracted by mini-css-extract-plugin
export var brand = "_3y-9";
export var compact = "_3y-6";
export var extraSmall = "_3y-7";
export var icon = "_3y-0";
export var large = "_3y-4";
export var light = "_3y-1";
export var medium = "_3y-5";
export var outline = "_3y-b";
export var primaryDark = "_3y-a";
export var primaryLight = "_3y-8";
export var primaryModern = "_3y-c";
export var success = "_3y-2";
export var successSolid = "_3y-3";